import React from 'react';
import PropTypes from 'prop-types';

const ReportsPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M11 21h2v-7h2v7h2v-5h2v5h2V11h2v10h2v1H7v-1h2v-3h2v3zM5 6h22c.552 0 1 .455 1 .992v18.016A.996.996 0 0 1 27 26H5c-.552 0-1-.455-1-.992V6.992A.996.996 0 0 1 5 6z"
    />
  );
};

ReportsPath.propTypes = {
  fill: PropTypes.string,
};

export default ReportsPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/reports.jsx